import type { SerializedLexicalNode } from "lexical";
import { useCallback } from "react";
import { usePublishDesignHuddleTemplateWithTags } from "../../../design-huddle/use-publish-template-with-tags";
import type { SerializedDesignHuddleNode } from "../../../message/editor/nodes/design-huddle-node";

const extractDesignHuddleNodes = (node: SerializedLexicalNode): SerializedDesignHuddleNode[] => {
  const nodes: SerializedDesignHuddleNode[] = [];

  if (node.type === "design-huddle") {
    nodes.push(node as SerializedDesignHuddleNode);
  }

  if ("children" in node && Array.isArray(node.children)) {
    for (const child of node.children) {
      nodes.push(...extractDesignHuddleNodes(child as SerializedLexicalNode));
    }
  }

  return nodes;
};

export const usePublishDesignHuddleNodes = (): ((
  lexicalDesign: SerializedLexicalNode,
) => Promise<void>) => {
  const publishDesignHuddleTemplate = usePublishDesignHuddleTemplateWithTags();

  return useCallback(
    async (lexicalDesign: SerializedLexicalNode) => {
      const designHuddleProjects = extractDesignHuddleNodes(lexicalDesign);

      await Promise.all(
        designHuddleProjects?.map(async (project) => {
          if (project.id) {
            const customisations = await publishDesignHuddleTemplate(project.id);
            if (customisations) {
              Object.assign(project, { customisations });
            }
          }
        }),
      );
    },
    [publishDesignHuddleTemplate],
  );
};
